import { Link } from 'react-router-dom';
import { testimonials } from '@/mocks/comics';

export default function SEOContent() {
  return (
    <>
      <section className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading">用户评价</h2>
            <p className="text-sm text-foreground-500 mt-1">看看漫友们怎么说</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {testimonials.map((item) => (
              <div key={item.id} className="p-5 bg-background-50 rounded-lg">
                <div className="flex items-center gap-1 mb-3">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i
                      key={i}
                      className={`text-sm ${i < item.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}
                    ></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  {item.comment}
                </p>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center text-primary-600 text-xs font-medium">
                      {item.name.charAt(0)}
                    </div>
                    <span className="text-sm font-medium text-foreground-700">{item.name}</span>
                  </div>
                  <span className="text-xs text-foreground-400">{item.date}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
        <div className="max-w-7xl mx-auto">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading text-center mb-8">
              关于韩国漫画网
            </h2>
            <div className="prose prose-sm max-w-none text-foreground-600 space-y-4">
              <p>
                <strong>韩国漫画网</strong>致力于为广大韩漫爱好者打造一个<strong>免费</strong>、便捷、高质量的<strong>韩漫在线阅读</strong>平台。我们深知每一位读者对精彩故事的渴望，因此汇聚了海量<strong>韩国漫画</strong>资源，覆盖恋爱、奇幻、动作、搞笑、悬疑等多种题材，形成完整的<strong>漫画大全</strong>，让您无需辗转多个网站，即可在这里找到心仪的作品。
              </p>
              <p>
                我们提供<strong>韩漫完整在线观看</strong>服务，所有漫画章节均支持高清流畅阅读。无论是正在连载的热门作品，还是已完结的经典之作，您都可以随时随地通过手机或电脑访问<strong>韩国漫画网</strong>，享受无缝的<strong>在线观看</strong>体验。我们的更新团队每日同步最新韩漫资源，确保您不会错过任何一个精彩章节。
              </p>
              <div className="flex flex-wrap gap-3 mt-6">
                <Link
                  to="/category/all"
                  className="px-5 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap"
                >
                  立即开始阅读
                </Link>
                <Link
                  to="/about"
                  className="px-5 py-2.5 bg-background-100 text-foreground-700 rounded-full text-sm font-medium hover:bg-background-200 transition-colors duration-200 whitespace-nowrap"
                >
                  了解更多
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}